import PromoCodes from './PromoCodes';
import PromoCodeSettings from './PromoCodeSettings';
import Details from './Details';

export default {
  PromoCodes,
  PromoCodeSettings,
  Details,
};
